<template>
  <div :class="divClass + ' avatar-wrapper'">
    <Avatar
      :background="background"
      color="white"
      :rounded="rounded"
      :size="size"
      :name="name"
      :imageSrc="avatar"
      :title="title || name"
      :status="status"
      :customAvatarStyle="{ color: 'white' }"
    />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Avatar from 'vue3-avatar';

export default defineComponent({
  name: 'avatar-component',
  components: { Avatar },
  props: {
    name: {
      type: String,
      required: true,
      default: function () {
        return 'John Doe';
      },
    },
    divClass: {
      type: String,
      required: false,
      default: () => {
        return '';
      },
    },
    status: {
      type: String,
      required: false,
      default: () => {
        return undefined;
      },
    },
    avatarClass: { type: String, required: false },
    avatar: { type: String, required: false },
    title: { type: String, required: false },
    background: { type: String, required: false },
    rounded: { type: Boolean, required: false, default: true },
    size: { type: Number, required: false, default: 40 },
  },
});
</script>
<style lang="scss">
.avatar {
  font-family: 'Roboto', sans-serif !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
}
// Target the inner container of Avatar inside our avatar-wrapper
.avatar-wrapper .container {
  all: unset !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  background: none !important;
  /* Optionally, reapply any needed layout properties */
  position: relative !important;
}
</style>
